import { useMemo } from 'react';

import { useHealthController_getQuality } from '@/services/hooks';
import type { HealthQualityResponseDto } from '@/services/types';

import type { DomainQueryOptions } from '../shared/types';

import { mapHealthQualityToDomain } from './mappers';
import type { UseGetHealthQualityResult } from './types';

/**
 * For the cage, or for the fish group named by `fishGroupId` (the page's `fg`). Without one the
 * request carries no query params.
 */
export function useGetHealthQuality(
    cageId: number,
    params: { fishGroupId?: number } = {},
    options?: DomainQueryOptions<HealthQualityResponseDto>
): UseGetHealthQualityResult {
    const query = useHealthController_getQuality(
        cageId,
        params.fishGroupId != null ? { fishGroupId: params.fishGroupId } : undefined,
        options
    );

    const healthQuality = useMemo(() => {
        if (!query.data?.data) {
            return null;
        }
        return mapHealthQualityToDomain(query.data.data);
    }, [query.data?.data]);

    return {
        data: healthQuality,
        isLoading: query.isPending,
        isFetching: query.isFetching,
        isFetched: query.isFetched,
        error: query.error,
        refetch: query.refetch,
    };
}
